import React, { Component } from 'react';
import {BulkItemInstance} from "./BulkItemInstance";
import Table, {TableColumn} from "../../Table";
import DurableFunctionInstanceStatus from "../../DurableFunctionInstanceStatus";
import {TableRowProps} from "../../TableRow";
import {Dropdown, IDropdownOption} from "office-ui-fabric-react";
import _ from "lodash";
import TableCell from "../../TableCell";
import ComparisonCounts from "../../../models/mailroom/comparison/ComparisonCounts";


const COLUMNS: TableColumn[] = [
    {
        title: "School",
        propertyPath: "input.schoolName",
        flex: 1
    },
    {
        title: "Original Processor",
        propertyPath: "input.processorInstanceId",
        flex: 1
    },
    {
        title: "Validation Processor",
        propertyPath: "ParsedOutput.comparisonSummary.secondInstanceId",
        flex: 1
    },
    {
        title: "Added",
        propertyPath: "counts.addedCount",
        flex: 1
    },
    {
        title: "Removed",
        propertyPath: "counts.removedCount",
        flex: 1
    },
    {
        title: "Changes",
        propertyPath: "counts.changedCount",
        flex: 1
    },
    {
        title: "Total",
        propertyPath: "counts.total",
        flex: 1
    },
    {
        title: "Error",
        propertyPath: "ParsedOutput.errorMessage",
        flex:1
    },
    {
        title: "Plan Error",
        propertyPath: "input.errorMessage",
        flex:1
    },
    {
        title: "Status",
        propertyPath: "status",
        flex:1
    }
]


interface BulkProcessorItemTableProps 
{
    bulkInstanceId: string;
    items: BulkItemInstance[];
}

interface BulkProcessorItemTableState {
    selectedProcessorItemType?: string;
}


export default class BulkProcessorItemTable extends Component<BulkProcessorItemTableProps, BulkProcessorItemTableState> {
    static displayName = BulkProcessorItemTable.name;

    constructor(props: BulkProcessorItemTableProps) {
        super(props);

        this.state = {
            selectedProcessorItemType: undefined
        };
    }
    
    private cellForColumn = (item: BulkItemInstance, column: TableColumn, columnIndex: number): JSX.Element | undefined => {

        
        console.log(item);
        
        if(column.propertyPath === "status")
        {
            return (
                <DurableFunctionInstanceStatus
                    durableFunctionInstance={item}
                    flex={column.flex}
                />
            );
        }
        
        const countsPrefix = "counts."
        if(column.propertyPath.startsWith(countsPrefix))
        {
            if(item.runtimeStatus !== "Completed" || !item.ParsedOutput?.comparisonSummary)
            {
                return (
                    <TableCell flex={column.flex}></TableCell>
                );
            }
            
            
            const propName = column.propertyPath.split(countsPrefix)[1];
            let counts: ComparisonCounts = item.ParsedOutput.comparisonSummary;
            if(this.state.selectedProcessorItemType !== undefined)
            {
                counts = item.ParsedOutput.comparisonSummary.breakdown.byProcessorItemType[this.state.selectedProcessorItemType!];
            }
            
            return (
                <TableCell flex={column.flex}>
                    <span>
                        {(counts as any)[propName]}
                    </span>
                </TableCell>
            )
        }

    }

    private rowPropsForItem = (item: BulkItemInstance): TableRowProps => {
        return {
            to: `/cdb-admin/mailroom/bulk-processor-comparison/${this.props.bulkInstanceId}/${item.durableFunctionInstanceId}`,
            enableRowLink: true
        };
    }
    
    private renderProcessorItemTypeDropdown()
    {
        let options: IDropdownOption[] = [];
        const completed = this.props.items.filter(x => x.runtimeStatus === "Completed");
        if(completed.length > 0)
        {
            options = _.keys(completed[0].ParsedOutput.comparisonSummary.breakdown.byProcessorItemType).filter(x => x !== "$type").map(processorItemType => {
                return {
                    key: processorItemType,
                    text: processorItemType,
                };
            });
        }
        
        return (
            <Dropdown label={"Processor Item Type"} options={options} onChange={(e,o) => this.setState({selectedProcessorItemType: o!.key as string})}/>
        );
    }
    
    render()
    {
        return (
            <Table
                columns={COLUMNS}
                items={this.props.items}
                emptyMessage={"No items"}
                cellForColumn={this.cellForColumn}
                rowPropsForItem={this.rowPropsForItem}
            >
                {this.renderProcessorItemTypeDropdown()}
                {this.props.children}
            </Table>
        );
    }
}